import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { images } from '../data/images';
import { practice } from '../data/site';
import { Reveal } from './ui/Reveal';
const facts = ['35+ years of experience', 'Family practice', 'Miami Lakes, Florida', 'Bilingual care'];
export function DoctorSection() {
  return <section id="dr-lima" className="scroll-mt-24 bg-white py-24 lg:py-40" data-id="element-170" data-mp="38yih8alq6zu3">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-171" data-mp="2l6tlek9p3t8e">
        <Reveal className="border-t border-ink/10 pt-10" data-id="element-172" data-mp="2g8joo58bokko">
          <p className="eyebrow flex items-center gap-3 text-ink/45" data-id="element-173" data-mp="2ga35py1syzni">
            <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-174" data-mp="2uxo6vmf4aoss" />
            Your dentist
          </p>
        </Reveal>

        <div className="mt-12 grid gap-14 lg:mt-16 lg:grid-cols-12 lg:gap-16" data-id="element-175" data-mp="2q5xvre8cvx0b">
          <Reveal className="lg:col-span-5" data-id="element-176" data-mp="22gby4v7mtpuf">
            <figure className="overflow-hidden rounded-[14px] bg-paper-off" data-id="element-177" data-mp="22f0qgkb2fxy1">
              <img src={images.doctorPortrait} alt="Dr. Julio Lima DDS, dentist at Lima Dental Group in Miami Lakes, Florida." loading="lazy" className="aspect-[4/5] h-full w-full object-cover object-[center_18%]" data-id="element-178" data-mp="1xhiqvkixuv2p" />
            </figure>
            <figcaption className="mt-5 text-[14px] leading-[1.7] text-ink/55" data-id="element-179" data-mp="qg9g3nhvmn4a">
              <span className="font-medium text-ink" data-id="element-180" data-mp="vcri4flto7cx">Dr. Julio C. Lima, DDS</span>
              <br data-id="element-181" data-mp="3utfzblwrplgr" />
              Lima Dental Group
              <br data-id="element-182" data-mp="3uur0rf2qqh4p" />
              Miami Lakes, FL
            </figcaption>
          </Reveal>

          <Reveal delay={0.08} className="flex flex-col justify-between lg:col-span-7 lg:py-4" data-id="element-183" data-mp="2qf3n71gz0kk">
            <div data-id="element-184" data-mp="7q1hnip4gkuf">
              <h2 className="font-display text-[clamp(2rem,4.2vw,3.3rem)] leading-[1.06] text-ink" data-id="element-185" data-mp="cmi50aohyv6g">
                A practice built
                <br data-id="element-186" data-mp="1j1skbl42am9r" />
                on <span className="font-display-em" data-id="element-187" data-mp="1j2lsmqio5ju0">trust</span>.
              </h2>

              <p className="mt-10 max-w-[54ch] text-[16.5px] leading-[1.9] text-ink/70" data-id="element-188" data-mp="1o0n9r5wjb92u">
                For more than 35 years, Dr. Julio Lima, DDS has cared for generations of patients
                with a simple philosophy: listen first, explain clearly, and recommend only the
                care each patient actually needs.
              </p>

              <p className="mt-8 max-w-[26ch] text-[clamp(1.3rem,2vw,1.7rem)] font-medium leading-[1.4] tracking-[-0.02em] text-ink/80" data-id="element-189" data-mp="13cw3tuvnbap7">
                “Explaining well is half of the treatment.”
              </p>
            </div>

            <div className="mt-14" data-id="element-190" data-mp="ap9r9x4fwvq7">
              <ul className="flex flex-wrap gap-x-10 gap-y-4 border-t border-ink/10 pt-7 text-[15px] text-ink/70" data-id="element-191" data-mp="aq1k506nkfcs">
                {facts.map(fact => <li key={fact} className="flex items-center gap-2.5" data-id="element-192" data-mp="km4li3tok9yo">
                    <span aria-hidden="true" className="h-1 w-1 rounded-full bg-accent" data-id="element-193" data-mp="3t1y5isn803kh" />
                    {fact}
                  </li>)}
              </ul>

              <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="group mt-10 inline-flex min-h-[52px] items-center gap-2.5 text-[14.5px] font-medium text-ink" data-id="element-194" data-mp="3o10leaingzgc">
                <span className="nav-link" data-id="element-195" data-mp="1to7n8gmafrfj">Book with Dr. Lima</span>
                <span className="hover-arrow text-accent" data-id="element-196" data-mp="1ylg7qnuws7jy">
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-197" data-mp="1yjwruyd5zyip" />
                </span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}